export default {
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_CUSTOMER_GROUP(state, customer_group) {
    state.customerGroups = customer_group;
  },
  ADD_CUSTOMER_GROUP(state, customer_group) {
    state.customerGroups.push(customer_group);
  },
  UPDATE_CUSTOMER_GROUP(state, customer_group) {
    const certIndex = state.customerGroups.findIndex(
      e => e.groupId === customer_group.groupId
    );
    Object.assign(state.customerGroups[certIndex], customer_group);
  },
  DELETE_CUSTOMER_GROUP(state, itemId) {
    const certIndex = state.customerGroups.findIndex(u => u.groupId === itemId);
    state.customerGroups.splice(certIndex, 1);
  }
};
